import { GetFlujoDeTesoreriaDisponibleByFacturaQueryDto } from "api/DTOs/GetFlujoDeTesoreriaDisponibleByFacturaQueryDto"
import { GetFlujoDeTesoreriaDisponibleByFacturaQueryDtoIPagedEnumerable } from "api/Schemas/GetFlujoDeTesoreriaDisponibleByFacturaQueryDtoIPagedEnumerable"
import { DATE_DD_MM_YYYY } from "common/components/FilterMenu/constants"
import { formatDate } from "common/utils/utils"

export default (
  data: GetFlujoDeTesoreriaDisponibleByFacturaQueryDtoIPagedEnumerable
) => {
  return data.items.map(
    (item: GetFlujoDeTesoreriaDisponibleByFacturaQueryDto) => ({
      id: item.id,
      identificador: item.numero,
      fecha: formatDate(item.fecha, DATE_DD_MM_YYYY),
      importe: item.importe,
      descripcion: item.descripcion,
    })
  )
}
